module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDExIDE1Ij4KICAgIDxwYXRoIGZpbGw9IiNBNkIwQkQiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEwLjgzOSAzLjczNkw3LjI2NC4xNjFBLjU1LjU1IDAgMCAwIDYuODc1IDBIMS4xQTEuMSAxLjEgMCAwIDAgMCAxLjF2MTIuMWExLjEgMS4xIDAgMCAwIDEuMSAxLjFoOC44YTEuMSAxLjEgMCAwIDAgMS4xLTEuMVY0LjEyNWEuNTUuNTUgMCAwIDAtLjE2MS0uMzg5ek03LjE1IDQuNGEuNTUuNTUgMCAwIDEtLjU1LS41NVYxLjA0N0w5Ljk1MyA0LjRINy4xNXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/file.svg
// module id = ./src/assets/file.svg
// module chunks = 0